export default "__VITE_ASSET__55b1b9e8__"